import { initializeApp } from "firebase/app";

import {
    getAuth,
    updateEmail,
    updatePassword,
    sendEmailVerification,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    updateProfile,
    onAuthStateChanged,
    signOut,
} from "firebase/auth";
import {
    getStorage,
    ref,
    uploadBytesResumable,
    getDownloadURL,
} from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyCKspK98fCuifrVPQqYSwnZR9OLhgPUEFA",
    authDomain: "edumed-e6ac3.firebaseapp.com",
    projectId: "edumed-e6ac3",
    storageBucket: "edumed-e6ac3.firebasestorage.app",
    messagingSenderId: "161373552998",
    appId: "1:161373552998:web:01a6ce82235e233f4408a7"
};


const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const storage = getStorage(app);




export { app, auth, storage };
